import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const imageLicenses = {
  col1: [
    "\u00a9 vege - Fotolia.com (ID: 61003743)",
    "\u00a9 vege - Fotolia.com (ID: 68888128)",
    "\u00a9 kraftwerk - Fotolia.com (ID: 43816459)",
    "\u00a9 stnazkul - Fotolia.com (ID: 70043857)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71558445)",
    "\u00a9 ty - Fotolia.com (ID: 69876126)",
    "\u00a9 stnazkul - Fotolia.com (ID: 74318288)",
  ],
  col2: [
    "\u00a9 everythingpossible - Fotolia.com (ID: 75176784)",
    "\u00a9 PRCreativeTeam - Fotolia.com (ID: 32926218)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 60594952)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71555591)",
    "\u00a9 kalafoto - Fotolia.com (ID: 76548158)",
    "\u00a9 Sergey Nivens - Fotolia.com (ID: 75074205)",
    "\u00a9 Minerva Studio - Fotolia.com (ID: 44001165)",
  ],
  col3: [
    "\u00a9 ty - Fotolia.com (ID: 77611976)",
    "\u00a9 Brian Jackson - Fotolia.com (ID: 71272430)",
    "\u00a9 vege - Fotolia.com (ID: 68009271)",
    "\u00a9 vege - Fotolia.com (ID: 69466546)",
    "\u00a9 lenetsnikolai - Fotolia.com (ID: 79605839)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 67233512)",
    "\u00a9 vege - Fotolia.com (ID: 68666829)",
  ],
  col4: [
    "\u00a9 vege - Fotolia.com (ID: 64727666)",
    "\u00a9 vege - Fotolia.com (ID: 68576622)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 53066900)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 68132249)",
    "\u00a9 vege - Fotolia.com (ID: 70085709)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71555523)",
    "\u00a9 bloomua - Fotolia.com (ID: 44334833)",
    "\u00a9 vege - Fotolia.com (ID: 69992403)",
  ],
};

export default function ImprintEnPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PageHead
        title="Legal Notice | NetBasis International"
        description="Legal notice, disclaimer, and image credits of NetBasis International in accordance with regulatory requirements."
        ogUrl="https://net-basis.net/en/legal-notice"
      />
      <Header />
      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero Image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src="https://net-basis.net/Bilder/netbasis-legal-notice-privacy-policy.webp"
                alt="Legal Notice"
                title="Legal Notice"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <div className="flex flex-col md:flex-row gap-10 md:gap-12 lg:gap-16">
              {/* Left Column - 1/3 */}
              <div className="w-full md:w-1/3">
                <section>
                  <h1 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
                    Legal Notice
                  </h1>

                  <div className="space-y-6">
                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Info pursuant to § 5 DDG
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Christof Günther{'\n'}NetBasis International{'\n'}Heinrichstraße 45{'\n'}40239 Düsseldorf{'\n'}Germany
                      </p>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Contact
                      </h2>
                      <div className="font-body text-sm md:text-base text-foreground-950 leading-relaxed space-y-1">
                        <p>
                          <span className="text-foreground-950">Phone:</span>{" "}
                          <a
                            href="tel:+4921154419380"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            +49 (0) 211 / 544 193 80
                          </a>
                        </p>
                        <p>
                          <span className="text-foreground-950">Email:</span>{" "}
                          <a
                            href="mailto:contact@net-basis.com"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            contact@net-basis.com
                          </a>
                        </p>
                        <p>
                          <span className="text-foreground-950">Internet:</span>{" "}
                          <a
                            href="https://net-basis.net/en"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            net-basis.net
                          </a>
                        </p>
                      </div>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        VAT Identification Number
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        VAT identification number pursuant to § 27 a UStG:{'\n'}DE 258 486 954
                      </p>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Professional Liability Insurance
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Name and registered office of the insurer:{'\n'}Hiscox AG acting on behalf of Hiscox Insurance Company Ltd.{'\n'}Branch office for Germany, Arnulfstraße 31, 80636 Munich{'\n'}Scope of coverage: Worldwide
                      </p>
                    </div>
                  </div>
                </section>
              </div>

              {/* Right Column - 2/3 */}
              <div className="w-full md:w-2/3">
                <section>
                  <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
                    Disclaimer
                  </h2>

                  <div className="space-y-6">
                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Liability for Content
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        The contents of our website have been created with the utmost care. However, we cannot guarantee the accuracy, completeness, and timeliness of the content. As a service provider, we are responsible for our own content on these pages in accordance with general laws. We are not obligated, however, to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information under general laws remain unaffected. However, liability in this regard is only possible from the point in time at which we become aware of a specific infringement. Upon becoming aware of corresponding legal violations, we will remove this content immediately.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Liability for Links
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Our offer contains links to external websites of third parties, on whose contents we have no influence. Therefore, we cannot assume any liability for these external contents. The respective provider or operator of the linked pages is always responsible for the content of the linked pages. The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognizable at the time of linking. However, a permanent content control of the linked pages is not reasonable without concrete evidence of a legal violation. Upon becoming aware of legal violations, we will remove such links immediately.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Copyright
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        The content and works created or used by us on these pages are subject to German copyright law. Reproduction, processing, distribution, and any kind of exploitation outside the limits of copyright require our consent. Downloads and copies of this site are only permitted for private, non-commercial use. Insofar as the content on our site was not created by us, the copyrights of third parties are respected. In particular, third-party content is identified as such. Should you nevertheless become aware of a copyright infringement, please inform us accordingly. Upon becoming aware of legal violations, we will remove such content immediately.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Image Credits
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        The Fotolia/Adobe Stock images used on this website have been properly licensed. Please refer to the following overview for detailed copyright notices:
                      </p>
                      <div className="mt-4 w-full">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-1">
                          {imageLicenses.col1.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col2.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col3.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col4.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}